var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCitasAgendadas = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.5,41.8v29.8h119V41.8c0-16.4,13.3-29.8,29.8-29.8S369,25.3,369,41.8v29.8h44.6c24.6,0,44.6,20,44.6,44.6 v44.6H41.8v-44.6c0-24.6,20-44.6,44.6-44.6H131V41.8c0-16.4,13.3-29.8,29.8-29.8S190.5,25.3,190.5,41.8z M41.8,190.5h416.5v252.9 c0,24.6-20,44.6-44.6,44.6H86.4c-24.6,0-44.6-20-44.6-44.6V190.5z M346.8,294.7c9.5-7.9,9.5-22,0-30.8c-7.9-8.6-22-8.6-30.8,0 l-88.3,88.4l-44.5-43.8c-7.9-8.6-22-8.6-30.8,0c-8.6,8.7-8.6,22.9,0,30.8l59.5,59.5c8.7,9.5,22.9,9.5,30.8,0L346.8,294.7z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCitasAgendadas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/citas_agendadas.d00b2d9c.svg";
export { ForwardRef as ReactComponent };